export default "skymp5-front/2147509d9ee4eeb0f3f3e366a4a3c76d.png";